import filterSubmissionsByMs from './filterSubmissionsByMs'
import periodRangeToMs from './periodRangeToMs'

// AI-CONTEXT: See docs/features/deep-analysis-period.md
// AI-CONTEXT: See docs/pitfalls.md#database-totaldocs-overcounts-respondents
//
// Period filter for sections that read QuestionnairesResponses themselves
// (no date in their query — a .where('Timestamp') would need a new composite
// index). Filters whole SUBMISSIONS, never loose answers (see
// filterSubmissionsByMs for the rule); this wrapper only turns the ISO period
// into local-day ms bounds and leaves the records alone without a period.

/**
 * @param {Array<object>} records - QuestionnairesResponses documents
 * @param {{start: string|null, end: string|null}|null|undefined} range - Period (null/empty = no filter)
 * @returns {Array<object>} The records of the submissions inside the period; the same array without a period
 */
const filterSubmissionsByPeriod = (records, range) => {
    if (!range || (!range.start && !range.end)) return records
    return filterSubmissionsByMs(records, periodRangeToMs(range))
}

export default filterSubmissionsByPeriod
